import { render, staticRenderFns } from "./ProspectFiche.vue?vue&type=template&id=55f2e28a"
import script from "./ProspectFiche.vue?vue&type=script&lang=ts"
export * from "./ProspectFiche.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports